import RootLayout from '@/component/wing/Layout';
import Img from '@/component/Img';
import useInitImg from '@/hooks/useInitImg';
import styles from './style.module.scss';

const features = [
  {
    title: 'Show Yourself',
    description: 'Share who you are and stand out. Build a complete Wing profile with clear photos, interest tags, a short bio, lifestyle details, and relationship goals. The more you share, the smarter Wing recommends, and the easier it is to spark authentic, on-topic conversations.',
    imageUrl: 'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik9ETFhHT1JCSVVLNkhSUUY0NDNURzdXTVNGM09aQiIsInciOjcxOCwiaCI6MTIzOCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMDI3NTA1NDc5ODMxNDQ4NzV9',
    imageLeft: false,
  },
  {
    title: 'Fun Convos',
    description: 'Break the ice in a tap. Wing suggests smart GIFs, emoji prompts, and ready-to-send openers that match your mood. Choose a vibe—playful, flirty, curious—and get tailored lines that keep chats flowing. Save favorites, personalize prompts, and filter content to stay respectful.',
    imageUrl: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkZMVUI1VjdPTklKN09UNFkyQVBVQldETExSN0RTWCIsInciOjcxOCwiaCI6MTIzOCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyMjk3Njg5MDYxMzQ1OTMwOTIxfQ',
    imageLeft: true,
  },
  {
    title: 'Great Love Thinks Alike',
    description: 'Connect over what matters. Wing\'s Daily Dating Quiz matches people who choose similar answers, helping you meet those who share your perspectives. Explore thousands of topics, compare takes, and discover chemistry rooted in values—so every new conversation starts with common ground.',
    imageUrl: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlNYVUdTWlBXWFJVU1ZGTURYSkdZTklMTVRHM0hPWCIsInciOjcxOCwiaCI6MTIzOCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjM2ODkyMTU3Mzk0ODQwOTgxNTV9',
    imageLeft: false,
  },
  {
    title: 'Love, Scentifically',
    description: 'Understand compatibility with clarity. Wing\'s Love Style Test uses science-backed psychology to map your strengths, needs, and dating patterns. See where you click, where you differ, and how to grow together—turning insight into better matches and more confident relationship choices.',
    imageUrl: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjQ3N0JNTTVFT05DQkxXNktWNUYyWkJVNDNQUUlYNCIsInciOjcxOCwiaCI6MTIzOCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMwNTIwNzE3NzIzNzQ3MTU1NjN9',
    imageLeft: true,
  },
];

const FeaturePage = () => {
  const imageUrls = features.map((f) => f.imageUrl);
  useInitImg(imageUrls);

  return (
    <RootLayout className={styles.wrapper}>
      <div className={styles.container}>
        {features.map((feature) => (
          <div
            key={feature.title}
            className={`${styles.featureSection}`}
          >
            {feature.imageLeft && (
              <div className={styles.imageContainer}>
                <Img src={feature.imageUrl} className={styles.phoneImage} />
              </div>
            )}
            <div className={styles.textContainer}>
              <h2 className={styles.title}>{feature.title}</h2>
              <p className={styles.description}>{feature.description}</p>
            </div>
            {!feature.imageLeft && (
              <div className={styles.imageContainer}>
                <Img src={feature.imageUrl} className={styles.phoneImage} />
              </div>
            )}
          </div>
        ))}
      </div>
    </RootLayout>
  );
};

export default FeaturePage;

